module.exports = __webpack_public_path__ + "d02baad177fca99e27384335a509dbf3.ttf";